import React, { ChangeEvent } from 'react';
import { useIntl } from 'react-intl';
import {
    IAccessoryOrder,
    IOption,
    sides,
} from '../../../../models/product-detail';
import { ISelectedOptionIds } from '../../../../models/product-detail';
import { isAvailableForSide } from './option-side-checking';

interface IMultiOptionProps {
    options: IOption[];
    label?: string;
    onChange: (rightSelectedIds: number[], leftSelectedIds: number[]) => void;
    selectedIds: ISelectedOptionIds;
    side: sides;
    isAccessory?: boolean;
    onAccessoryChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    selectedAccessories?: IAccessoryOrder[];
}

const MultiOption = ({
    options,
    label,
    onChange,
    selectedIds,
    side,
    isAccessory,
    onAccessoryChange,
    selectedAccessories,
}: IMultiOptionProps) => {
    const intl = useIntl();

    const updateSelectedIds = (event: React.ChangeEvent<HTMLInputElement>) => {
        const right = selectedIds.rightSelectedIds.concat([]);
        const left = selectedIds.leftSelectedIds.concat([]);

        if (event.target.checked) {
            right.push(parseInt(event.target.value));
            left.push(parseInt(event.target.value));
        } else {
            if (
                right.indexOf(parseInt(event.target.value)) >= 0 ||
                left.indexOf(parseInt(event.target.value)) >= 0
            ) {
                right.splice(right.indexOf(parseInt(event.target.value)), 1);
                left.splice(left.indexOf(parseInt(event.target.value)), 1);
            }
        }

        onChange(right, left);
    };

    const isChecked = (option: IOption) => {
        if (isAccessory) {
            return selectedAccessories!.some(
                (accessory) => accessory.partNumber === option.partNumber
            );
        } else {
            return (
                (side !== sides.left &&
                    selectedIds.rightSelectedIds.includes(option.id)) ||
                (side !== sides.right &&
                    selectedIds.leftSelectedIds.includes(option.id))
            );
        }
    };

    const setButtonStyle = (name: string) => {
        const defaultButtonStyle = 'btn button-label no-text-transform';
        if (name.length > 50) {
            return defaultButtonStyle + ' button-wrap';
        } else {
            return defaultButtonStyle;
        }
    };

    return (
        <div>
            {label && (
                <div className="row">
                    <div className="col-md-12">
                        <h4>
                            {intl.formatMessage({
                                id: label,
                                defaultMessage: label,
                            })}
                        </h4>
                    </div>
                </div>
            )}
            <div className="col-md-12">
                {options.map((option) => {
                    if (
                        !option.hidden &&
                        isAvailableForSide(
                            side,
                            option.isAvailableLeft,
                            option.isAvailableRight
                        )
                    ) {
                        return (
                            <div key={option.id}>
                                <p
                                    className="color-select"
                                    style={{
                                        marginRight: '10px',
                                    }}
                                >
                                    <input
                                        type={'checkbox'}
                                        id={option.name}
                                        value={
                                            isAccessory
                                                ? option.partNumber
                                                : option.id
                                        }
                                        checked={isChecked(option)}
                                        onChange={
                                            isAccessory
                                                ? onAccessoryChange
                                                : updateSelectedIds
                                        }
                                    />
                                    <label
                                        className={setButtonStyle(option.name)}
                                        style={{ border: '1px solid #1e9be9' }}
                                        htmlFor={option.name}
                                        dangerouslySetInnerHTML={{
                                            __html: isChecked(option)
                                                ? `&#x2611  ${intl.formatMessage(
                                                      {
                                                          id: option.english
                                                              .replace(' ', '_')
                                                              .replace(
                                                                  '&',
                                                                  'AND'
                                                              ),
                                                          defaultMessage:
                                                              option.name,
                                                      }
                                                  )}`
                                                : `&#9744  ${intl.formatMessage(
                                                      {
                                                          id: option.english
                                                              .replace(' ', '_')
                                                              .replace(
                                                                  '&',
                                                                  'AND'
                                                              ),
                                                          defaultMessage:
                                                              option.name,
                                                      }
                                                  )}`,
                                        }}
                                    />
                                </p>
                                {option.id === 158 && (
                                    <p>
                                        {intl.formatMessage({
                                            id: '*If_the_size_and_shape',
                                            defaultMessage: `*If the size and shape of the ear does
                                        not allow for a secure retention point
                                        for the model ordered, a canal lock may
                                        be added to ensure a good physical fit. `,
                                        })}{' '}
                                    </p>
                                )}
                                {(option.id === 122 || option.id === 469) && (
                                    <p>
                                        {intl.formatMessage({
                                            id: 'Directionality_may_update_mat',
                                            defaultMessage:
                                                '(Directionality may update matrix)',
                                        })}{' '}
                                    </p>
                                )}
                            </div>
                        );
                    } else {
                        return null;
                    }
                })}
            </div>
        </div>
    );
};

export default MultiOption;
